// TypedText.js
import React, { useEffect } from "react";
import Typed from "typed.js";

const TypedText = () => {
  useEffect(() => {
    const options = {
      strings: [
        "Entrepreneur",
        "Lifestyle Influencer",
        "Web Application Developer",
        "Cinematographer",
        "Food Blogger",
        "Youtuber",
        "Content Creator",
        "Fashion Model",
      ],
      typeSpeed: 50,
      backSpeed: 100,
      backDelay: 1000,
      loop: true,
    };

    const typed = new Typed(".typed-text", options);

    return () => {
      typed.destroy();
    };
  }, []);

    return <span className="typed-text span"></span>;
};

export default TypedText;
